import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@/routes/utils";

const baseRoute = `/user-management/admin`;

export const adminsRoutesObj = {
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:adminId`,
} as const;

export type IAdminsRouteParams = IExtractRouteParamMap<typeof adminsRoutesObj>;

export const adminsPath = createPaths<
  typeof adminsRoutesObj,
  IAdminsRouteParams
>(adminsRoutesObj);
